
<div class="flex flex-col justify-around flex-wrap {{class}}" id="impactscores">
  <div class="flex flex-row justify-around flex-wrap">
    @if (getScore('_TRUECOSTS')) {
      <div class="text-center m-1">
        <div class="pie animate m-auto">
          <img class="w-10" alt="vegetablecounter" src="assets/images/icons/icon_trueprice.svg" />
        </div>
        <small class="flex flex-col mt-2.5">
          <strong class="d-block">{{'score.truecosts'| translate}}</strong>
          <span class="d-block text-lowercase">@if (getScore('_TRUECOSTS')?.scoreimprovement > 0) {
            <span>-</span>
          } {{getScore('_TRUECOSTS')?.scoreimprovement |currency: 'EUR':'symbol':'.2-2':'nl'}}</span>
        </small>
      </div>
    }
    @if (getScore('_VETGETABLESCORE')) {
      <div class="text-center m-1">
        <div class="pie animate m-auto">
          <img class="w-10" alt="vegetablecounter" src="assets/images/icons/icon_DG-groenteteller.svg" />
        </div>
        <small class="flex flex-col mt-2.5">
          <strong class="d-block">{{'score.veggiescore'| translate}}</strong>
          <span class="d-block text-lowercase">@if (getScore('_VETGETABLESCORE')?.scoreimprovement > 0) {
            <span>+</span>
          } {{getScore('_VETGETABLESCORE')?.scoreimprovement | number: '1.0-1'}} {{'unit_abbr.GRAM' |translate}}</span>
        </small>
      </div>
    }
    @if (getScore('VITASCORERISCPOINTS')) {
      <div class="text-center m-1">
        <div class="pie animate m-auto">
          <img class="w-[50px]" alt="vita-score" src="assets/images/icons/icon_DG-vitaliteit.svg" />
        </div>
        <small class="flex flex-col mt-2.5">
          <strong class="d-block">{{'score.vitascore'| translate}}</strong>
          <span class="d-block text-lowercase">@if (getScore('VITASCORERISCPOINTS')?.scoreimprovement < 0) {
            <span>+</span>
          } {{getScore('VITASCORERISCPOINTS')?.scoreimprovement * -1 | number: '1.0-1'}} {{'unit.POINTS' |translate}}</span>
        </small>
      </div>
    }
    @if (getScore('CARBONSCORE')) {
      <div class="text-center m-1">
        <div class="pie animate m-auto">
          <img class="w-[50px]" alt="co2-reduction-score" src="assets/images/icons/icon_DG-CO2eq.svg" />
        </div>
        <small class="flex flex-col mt-2.5">
          <strong class="d-block text-nowrap">CO<sub>2</sub>{{'score.co2eq-score'| translate}}</strong>
          <span class="d-block text-lowercase">@if (getScore('CARBONSCORE')?.scoreimprovement > 0) {
            <span>-</span>
          } {{getScore('CARBONSCORE')?.scoreimprovement | number: '1.0-1'}} {{'unit_abbr.GRAM' |translate}}</span>
        </small>
      </div>
    }
    @if (getScore('SCARCEWATERUSAGE')) {
      <div class="text-center m-1">
        <div class="pie animate m-auto">
          <img class="w-[30px]" alt="water-reduction-score" src="assets/images/icons/icon_DG-water.svg" />
        </div>
        <small class="flex flex-col mt-2.5">
          <strong class="d-block">{{'score.waterscore'| translate}}</strong>
          <small class="d-block text-lowercase">@if (getScore('SCARCEWATERUSAGE')?.scoreimprovement > 0) {
            <span>-</span>
          } {{getScore('SCARCEWATERUSAGE')?.scoreimprovement | number: '1.0-1'}} {{'unit_abbr.LITER' |translate}}</small>
        </small>
      </div>
    }
  </div>
  <div class="flex flex-row flex-wrap justify-between mt-2">
    <small><a class="hover:underline" routerLink="/{{'score.learn_more_url'| translate}}">{{'score.learn_more'| translate}} <i class="bi bi-arrow-right"></i></a></small>
    <small class="text-end text-xs">{{'score.note'| translate}}</small>
  </div>
</div>



